<template>
  <v-dialog max-width="400px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Worker Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="8" md="8">
            <r-worker-key :model.sync="model.worker" hide-details/>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model.number="model.capacity" label="Capacity (units):" hide-details/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model.number="model.sleepTime" label="SleepTime:" hide-details/>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model.number="model.rushTime" label="RushTime:" hide-details/>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model.number="model.lifeTime" label="LifeTime:" hide-details/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <v-checkbox v-model="model.public" label="Public" hide-details/>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-checkbox v-model="model.shared" label="Shared" hide-details/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {WorkerConfig} from "@/modules/redactor/models/worker/WorkerConfig";
import RWorkerKey from "@/modules/redactor/views/worker/r-worker-key";


export default {
  name: "r-worker-config",
  components: {RWorkerKey},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: VueTypes.objectOf(WorkerConfig),
    rules: ViewRules.READONLY,
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new WorkerConfig();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {

      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}
</script>